export const SET_ACTIVE_CAMPAGNE = 'SET_ACTIVE_CAMPAGNE'

export const setActiveCampagne = (campagne) => dispatch => {
	return dispatch({
		type: SET_ACTIVE_CAMPAGNE,
		campagne
	})
}
